var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-desc"},[_c('div',{staticClass:"desc-title"},[_c('i',{staticClass:"el-icon-chat-dot-round"}),_vm._v(" 授权说明 ")]),_c('ol',[_c('li',[_vm._v(" 淘宝联盟限制每次授权有效期为30天，到期前请及时重新授权，否则将导致淘客相关功能失效。 ")]),_c('li',[_vm._v("同一淘宝账号仅能授权给一个账号，如需重复授权则需要先从原先账号中解除授权")]),_c('li',[_vm._v(" 目前暂不限制可授权的淘宝账号数量，但不排除未来可能会限制授权数量的可能性 ")])])])
}]

export { render, staticRenderFns }